import Vue from "vue";
import Vuex from  "vuex"
import {store} from "./store/store.js";
import App from "./App.vue";
import appPaths from "./util/appPaths";

import VueRouter from "vue-router";
import {router} from "./router";

import * as filters from "./util/filters.js";
import cookieUtils from "./util/cookieUtils";

import axios from 'axios'
import VueAxios from 'vue-axios'
import authMixin from "./mixin/authMixin";

import Vuetify from "vuetify";

Vue.use(Vuetify);
import "vuetify/dist/vuetify.min.css";

// import appConstants from "/src/plugins/appConstants";

// new Vue({
//     store,
//     router,
//     vuetify: new Vuetify(), //<-----
//     render: (h) => h(App),
// }).$mount("#app");

window.resetState = () => {
    localStorage.clear();

    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        if(name !== "token")
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }

    location.reload();
}

store.commit("setDefaults");

for(let filter in filters){
    Vue.filter(filter,filters[filter]);
}

// console.log(appConstants);

Vue.use(VueRouter);
const routerWithOptions = new VueRouter(
    {
        routes: router,
        mode: "history",
        scrollBehavior() {
            return { x: 0, y: 0 };
        },
    }
);



Vue.use(VueAxios, axios)

Vue.use(Vuex)
Vue.mixin(appPaths);
Vue.mixin(authMixin);
//VUE APP
new Vue({
    el:'#app',
    router:routerWithOptions,
    store,
    vuetify: new Vuetify(), //<-----
    beforeCreate() {
        let token = cookieUtils.getCookie("token");

        if(token === null) {
            if(this.$route.path !== "/login")
                this.$router.push("/login")
        }else{
            $(".preloader").show()
            this.$store.dispatch("reLogin", token).then((response) => {
                if(this.$route.path === "/login")
                    this.$router.push("/")
                $(".preloader").hide();
            }).catch(reason => {
                if(this.$route.path !== "/login")
                    this.$router.push("/login")
                $(".preloader").hide();
            })
        }
    },
    render: h => h(App),
})